import Vue from "vue";
import Vuex from "vuex";
import {
  Ajax,
  baseURL
} from "@/ajax";
import router from "@/router";
import Cookies from "js-cookie";
import { Toast } from "vant";
import {
  Message,
  Modal
} from "iview";
import {
  debounce
} from "riku-verycloud";

Vue.use(Vuex);
const storage = window.localStorage;
const localStorageKey = "qiannian";
const localStorage = storage.getItem(localStorageKey) ?
  JSON.parse(storage.getItem(localStorageKey)) :
  {};

const state = {
  ready: false,
  accessToken: "", //0cf77e4337f3f77d8e16fe2bc08b33baaf40e004 Cookies.get('accessToken')
  refreshToken: "", //Cookies.get('refreshToken')
  userId: "",

  version: "", //'1.0.1'
  bundle_id: "", //'com.qnhz.game'
  plat: "", //'ios'
  udid: "", //'B03202E3-0835-4982-A330-08F26085E99C'
  app_key: "", //'8b135dba87eb2c'

  shopkey: '', //商品订单列表关键字搜索
  differTime: 0, //服务器时间

  userData: null,

  buyInfo: storage.getItem("buyInfo"),
  buyPrice: storage.getItem("buyPrice") || 0,

  errorQueue: new Set(),
  ...localStorage,
}

const getters = {
  state(state) {
    return state;
  },
};

const mutations = {
  state(state, obj) {
    Object.assign(state, obj)
  },
  setParams(state, obj) {
    state.version = obj.version
    state.bundle_id = obj.bundle_id
    state.plat = obj.plat
    state.udid = obj.udid
    state.app_key = obj.app_key
  },
  setUserInfo(state, obj) {
    state.accessToken = obj.accessToken
    state.refreshToken = obj.refreshToken
    state.userId = obj.userId
  },
  isReady(state, boolean) {
    state.ready = boolean
  },
  setShopkey(state, key) {
    state.shopkey = key
  },


  setBuyInfo(state, info) {
    state.buyInfo = info;
    storage.setItem("buyInfo", info);
  },
  setBuyPrice(state, price) {
    state.buyPrice = price;
    storage.setItem("buyPrice", price);
  },
  setServiceTime(state, date) {
    let localTime = new Date();
    let serveTime = new Date(date);
    state.differTime = localTime.valueOf() - serveTime.valueOf();
  }
}

const actions = {
  setCookies: ({
    commit
  }, {
    userId,
    accessToken,
    accessExpire,
    refreshToken,
    refreshExpire
  }) => {
    Cookies.set("accessToken", accessToken, {
      expires: (accessExpire - new Date().getTime() / 1000) / 86400,
    });
    Cookies.set("refreshToken", refreshToken, {
      expires: (refreshExpire - new Date().getTime() / 1000) / 86400,
    });
    commit("state", {
      accessToken,
      refreshToken,
    });
  },
  refreshToken: async ({
    commit,
    dispatch
  }, refreshToken) => {
    let rs = await Ajax(
      "refresh-token", {
        refreshToken,
      }, {
        auth: false,
      }
    );
    if (rs.code == 200) {
      await dispatch("setCookies", rs.data);
      return rs.data.accessToken;
    }
  },
  getUserData: async ({
    commit
  }, cacheClear) => {
    if (cacheClear || !state.userData) {
      const rs = await Ajax("user/userinfo", {
        "Access-Token": state.accessToken,
      });
      const userData = rs.data;
      commit("state", {
        userData,
      });
    }
  },
  pushError: ({
    commit,
    dispatch
  }, error) => {
    state.errorQueue.add(error);
    dispatch("delayError");
  },
  delayError: debounce(() => {
    for (let msg of [...state.errorQueue]) {
      if (msg && typeof msg == "string") {
        Toast(msg);
      } else {
        console.warn(msg);
      }
    }
    state.errorQueue.clear();
  }, 500),
};

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
});
export default store;